const PRODUCTS_UPDATED = (state, products) => {
  state.products = products;
};

export default {
  PRODUCTS_UPDATED,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/mutations.js